import {
  INVALIDATE_HOT100,
  RECEIVE_HOT100_ARCHIVE,
  REQUEST_HOT100_ARCHIVE,
  REQUEST_HOT100,
  RECEIVE_HOT100,
  HOT100_POSITION,
  INVALIDATE_TOP20,
  REQUEST_TOP20,
  RECEIVE_TOP20,
  REQUEST_TOP20_COUNTER,
  RECEIVE_TOP20_COUNTER,
  INVALIDATE_PRIZES,
  REQUEST_PRIZES,
  RECEIVE_PRIZES,
  INVALIDATE_RADIOTHON_DAILY,
  REQUEST_RADIOTHON_DAILY,
  RECEIVE_RADIOTHON_DAILY,
  INVALIDATE_STATION_UPDATES,
  REQUEST_STATION_UPDATES,
  RECEIVE_STATION_UPDATES,
  INVALIDATE_BNA,
  REQUEST_BNA,
  RECEIVE_BNA,
  INVALIDATE_AOTW,
  REQUEST_AOTW,
  RECEIVE_AOTW,
  INVALIDATE_EOY_TOP10,
  REQUEST_EOY_TOP10,
  RECEIVE_EOY_TOP10,
  REQUEST_EOY_TOP10_FULL,
  RECEIVE_EOY_TOP10_FULL,
	REQUEST_PODCAST,
	RECEIVE_PODCAST
} from './actions'
 

export function hot100Archive(
  state = {
    isFetching: false,
    didInvalidate: false,
    position: null,
    items: []
  },
  action
) {
  switch (action.type) {
    case REQUEST_HOT100_ARCHIVE:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_HOT100_ARCHIVE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.hot100Archive,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function hot100(
  state = {
    isFetching: false,
    didInvalidate: false,
    position: null,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_HOT100:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_HOT100:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_HOT100:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.hot100,
        lastUpdated: action.receivedAt
      })
    case HOT100_POSITION:
      return Object.assign({}, state, {
        position: action.hot100Position,
      })
    default:
      return state
  }
}

export function prizes(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    category: null
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_PRIZES:
      return Object.assign({}, state, {
        didInvalidate: true,
        category: action.category
      })
    case REQUEST_PRIZES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false,
        category: action.category
      })
    case RECEIVE_PRIZES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.prizes,
        lastUpdated: action.receivedAt,
        category: action.category
      })
    default:
      return state
  }
}

export function radiothonDaily(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_RADIOTHON_DAILY:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_RADIOTHON_DAILY:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_RADIOTHON_DAILY:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.radiothonDaily,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function stationUpdates(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_STATION_UPDATES:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_STATION_UPDATES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_STATION_UPDATES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.stationUpdates,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function podcastFeed(
	state = {
		isFetching: false,
		feed: {}
	},
	action
) {
	switch (action.type) {
		case REQUEST_PODCAST:
			return { ...state, isFetching: true }
		case RECEIVE_PODCAST:
			return { ...state, isFetching: false, feed: action.feed }
		default:
			return state;
	}
}

export function top20(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    counter: 20
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_TOP20:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_TOP20:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_TOP20:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        ...action.top20,
        items: action.top20set,
        lastUpdated: action.receivedAt
      })
    case REQUEST_TOP20_COUNTER:
      return state
    case RECEIVE_TOP20_COUNTER:
      return Object.assign({}, state, {
        counter: action.top20Counter,
      })
    default:
      return state
  }
}

export function BNA(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_BNA:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_BNA:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_BNA:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.BNA,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}


export function AOTW(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_AOTW:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_AOTW:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_AOTW:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.AOTW,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}


export function EOYTop10(
  state = {
    isFetching: false,
    isFetchingFull: false,
    didInvalidate: false,
    didInvalidateFull: false,
    items: [],
    full: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_EOY_TOP10:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_EOY_TOP10:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_EOY_TOP10:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.EOYTop10,
        lastUpdated: action.receivedAt
      })
    case REQUEST_EOY_TOP10_FULL:
      return Object.assign({}, state, {
        isFetchingFull: true,
        didInvalidateFull: false
      })
    case RECEIVE_EOY_TOP10_FULL:
      return Object.assign({}, state, {
        isFetchingFull: false,
        didInvalidateFull: false,
        full: action.EOYTop10Full,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}
